module.exports = __webpack_public_path__ + "static/media/photo-9.fa27d0de.webp";